import asyncLoadView from 'utils/asyncLoadView/asyncLoadView';
import routeArgsToInt from 'router/utils/routeArgsToInt';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import AccountPage from 'pages/accounts/AccountPage';
import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import accountConnectionsRoutes from 'router/routes/accounts/connections';
import accountRolesRoutes from 'router/routes/accounts/roles';
import accountClosureRoutes from 'router/routes/accounts/closure';
import accountFinancesRoutes from 'router/routes/accounts/finances';
import accountPayersRoutes from 'router/routes/accounts/payers';
import accountAdvertisersRoutes from 'router/routes/accounts/advertisers';
import accountBrandsRoutes from 'router/routes/accounts/brands';
import accountAdditionalServicesRoutes from 'router/routes/accounts/additionalServices';
import accountCompaniesRoutes from 'router/routes/accounts/companies';
import accountContractsRoutes from 'router/routes/accounts/contracts';
import accountCustomersRoutes from 'router/routes/accounts/customers';
import accountStatisticsRoutes from 'router/routes/accounts/statistics';
import accountMarkupsRoutes from 'router/routes/accounts/markups';
import accountSyncRoutes from 'router/routes/accounts/sync';
import accountRoreRoutes from 'router/routes/accounts/rore/rore';
import translation from 'translation';
import store from 'store';
import AccountsNestedPage from 'layouts/nested/account/AccountsNestedPage';
import SimpleNestedPage from 'layouts/nested/simple/SimpleNestedPage';
import accountOrdersRoutes from 'router/routes/accounts/orders';
import accountToolsRoutes from 'router/routes/accounts/tools';

const accountRoutes = [
  {
    path: '/accounts/search',
    name: 'accountsSearch',
    component: wrapLegacyRoute('searchController', 'search')
  },
  {
    path: '/accounts/createRoot',
    name: 'accountCreateRoot',
    component: wrapLegacyRoute('accountsController', 'createRoot')
  },
  {
    path: '/accounts',
    component: NestedRouteComponent,
    meta: {
      nestedName: 'accounts_nested'
    },
    children: [
      {
        path: '',
        component: SimpleNestedPage,
        children: [
          {
            path: '',
            name: 'accounts',
            component: () => asyncLoadView(import('pages/accounts/AccountsListPage')),
            meta: {
              routeName: {
                name: () => translation.tr('All accounts')
              }
            },
            props: routeArgsToInt
          }
        ]
      },
      {
        path: ':accountId(\\d+)',
        component: AccountsNestedPage,
        meta: {
          routeName: {
            segmentName: () => store.getters['accounts/currentAccount'].name
          }
        },
        children: [
          {
            path: '',
            name: 'account',
            component: AccountPage,
            meta: {
              usualAccountRedirectRoute: 'projectsList'
            },
            props: routeArgsToInt
          },
          {
            path: 'old',
            name: 'accountsListOld',
            component: wrapLegacyRoute('accountsController', 'list')
          },
          {
            path: 'view',
            name: 'accountView',
            component: wrapLegacyRoute('accountsController', 'accountView')
          },
          {
            path: 'create',
            name: 'accountCreate',
            meta: {
              routeName: {
                segmentName: () => translation.tr('Account creation')
              }
            },
            component: wrapLegacyRoute('accountsController', 'create')
          },
          {
            path: 'search',
            name: 'accountSearch',
            meta: {
              routeName: {
                segmentName: () => translation.tr('Find in accounts')
              }
            },
            component: wrapLegacyRoute('searchController', 'search')
          },
          {
            path: 'projects',
            name: 'projectsList',
            meta: {
              permissions: ['READ_PROJECTS']
            },
            component: () => asyncLoadView(import('pages/accounts/AccountProjectsListPage/AccountProjectListPage')),
            props: routeArgsToInt
          },
          {
            path: 'projects/create',
            name: 'projectCreate',
            component: wrapLegacyRoute('projectsController', 'create')
          },
          ...accountRolesRoutes,
          ...accountConnectionsRoutes,
          {
            path: 'orders',
            name: 'accountOrders',
            meta: {
              permissions: ['READ_ORDERS'],
              routeName: {
                segmentName: () => translation.tr('Orders')
              }
            },
            component: wrapLegacyRoute('accountsController', 'orders')
          },
          ...accountOrdersRoutes,
          ...accountStatisticsRoutes,
          {
            path: 'history',
            name: 'accountHistory',
            meta: {
              routeName: {
                segmentName: () => translation.tr('History')
              },
              permissions: ['READ_ACCOUNT_HISTORY']
            },
            component: wrapLegacyRoute('historyController', 'accountHistory')
          },
          {
            path: 'settings',
            meta: {
              routeName: {
                segmentName: () => translation.tr('Settings')
              },
              permissions: ['UPDATE_ACCOUNT']
            },
            component: NestedRouteComponent,
            children: [
              {
                path: '',
                name: 'accountSettings',
                component: wrapLegacyRoute('accountsController', 'settings')
              },
              {
                path: 'subscription',
                name: 'userAccountSubscription',
                meta: {
                  routeName: {
                    segmentName: () => translation.tr('Notifications')
                  }
                },
                component: wrapLegacyRoute('accountsController', 'subscription')
              },
              {
                path: 'vat',
                name: 'accountVatList',
                meta: {
                  routeName: {
                    segmentName: () => translation.tr('VAT')
                  }
                },
                component: wrapLegacyRoute('accountsController', 'accountVatList')
              }
            ]
          },
          {
            path: '',
            component: NestedRouteComponent,
            meta: {
              routeName: {
                segmentName: () => translation.tr('Reference')
              }
            },
            children: [
              ...accountPayersRoutes,
              ...accountAdvertisersRoutes,
              ...accountAdditionalServicesRoutes,
              ...accountBrandsRoutes,
              ...accountContractsRoutes,
              ...accountCustomersRoutes,
              ...accountCompaniesRoutes,
              ...accountMarkupsRoutes
            ]
          },
          ...accountSyncRoutes,
          {
            path: 'financialreports/bill/report',
            name: 'billReport',
            meta: {
              routeName: {
                segmentName: () => translation.tr('Bill report')
              },
              permissions: ['READ_BILL_REPORT']
            },
            component: wrapLegacyRoute('financialReportsController', 'billReport')
          },

          ...accountClosureRoutes,
          ...accountFinancesRoutes,

          ...accountRoreRoutes,
          ...accountToolsRoutes
        ]
      }
    ]
  }
];

export default accountRoutes;
